"use client";

import { useEffect, useState } from "react";

/**
 * A ticking clock for countdowns.
 *
 * Starts at `null` and fills in on mount rather than reading the clock during
 * render: a server-rendered "starts in 04:12" would be wrong for every reader
 * who arrived a minute later, and hydration would disagree with itself.
 */
export function useNow(intervalMs = 1000): number | null {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}
